var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLongArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 157,
    viewBox: "0 0 48 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6021 14.4759C18.4772 19.6634 14.8486 25.2874 11.7918 31.2484C5.67837 43.1704 1.91148 56.413 0.839341 70.0262C-0.246905 83.6244 1.33252 97.5925 5.65349 110.842C7.79944 117.466 10.62 123.906 14.0604 130.045C17.5009 136.184 21.5621 141.992 26.1594 147.379L17.1658 155.856L46.3504 156.72L47.2143 127.535L38.1309 136.096C33.7591 131.937 29.763 127.368 26.23 122.39C22.7111 117.427 19.6544 112.085 17.1586 106.469C12.1528 95.2217 9.34753 82.8611 9.03659 70.2688C8.71069 57.6907 10.8924 44.9249 15.5243 32.93C17.8402 26.9325 20.7605 21.1566 24.2395 15.6735C27.7185 10.1905 31.7694 5.04449 36.3033 0.290965C31.3331 4.55153 26.7269 9.28838 22.6021 14.4759Z",
    fill: "#1A3950"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongArrowDown);
export default __webpack_public_path__ + "static/media/long-arrow-down.aa89672f571b3620fdeb5b9464b64064.svg";
export { ForwardRef as ReactComponent };